module.exports = __webpack_public_path__ + "static/media/sCollins.d226ea1e.jpeg";